
const probabilityMeasureRoutes = [
    {
        path: '/probability-measure',
        name: 'ProbabilityMeasurePage',
        component: () => import('../views/probabilityMeasureTypes/ProbabilityMeasureTypesComponent.vue'),
        meta: {
            requiresAuth: true,
            roles: ['ADMIN'],
            permission: 'probabilityMeasures',
            module: 'risksManagement',
            planFeature: 'advanced_config',

        },
    },

];

export default probabilityMeasureRoutes;